import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcGridComponent — solid 2×2 grid icon (dashboard / stock overview).
 */
@Component({
  selector: 'ic-grid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-grid.html',
})
export class IcGridComponent {
  @Input() startColor: string | null = null;
  @Input() endColor: string | null = null;
  @Input() opacity = 1;
  @Input() width: number | string = 14;
  @Input() height: number | string = 14;
  @Input() color = '';
  @Input() defaultColor = 'var(--color-icon-deactivated)';

  gradientId = `gridGradient-${Math.random().toString(36).slice(2)}`;

  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
